import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import FontAwesome from 'react-fontawesome'

import AttachedFilesBox from '../Shared/AttachedFilesBox'
import Box from '../Layout/Box'
import BoxSection from '../Layout/BoxSection'
import ModalAddVerificacionSOMA from '../Documentos/ModalAddVerificacionSOMA'

import { showHideModalCreateEntrega } from '../../actions/documentos'
import { showHideModalAddVerificacionSOMA, getParameterByName } from '../../actions/common'

import { height } from 'window-size'
import { isAllowedToViewComponent, getDivisa, formatcoin } from '../../utils/helpers'

class Entregas extends Component {


    componentWillMount() {
        this.props.getParameterByName('CRITERIOS_EVALUACION_PROVEEDORES')
    }


    promediar = (criterio) => { 
        
        const entregas = this.props.documento.get('entregas').filter(e => e.get('recibido') == 1);

        const total = entregas.reduce((a,b) => {
            const criterios = b.get('evaluaciones').filter(x => x.get('criterio') == criterio)
            a += criterios.count() > 0 ? (criterios.first().get('calificacion') ? criterios.first().get('calificacion') : 0) : 0
            return a
        }, 0)

        return entregas.count() > 0 ? (total/entregas.count()).toFixed() : 0;



    }

    renderEvaluaciones(entrega, divisa) {

        if (!entrega.get('recibido')) return null


        return (
            <div className="row" style={{ marginBottom: '5px' }}>
                <div className="col-md-12">
                    <table className="table table-condensed table-bordered">
                        <thead>
                            <tr>
                                <th>Criterio</th>
                                <th>Calificación</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                entrega.get('evaluaciones').map((c, d) => {
                                    return (
                                        <tr key={ `tr8[${c.get('id')}]` }>
                                            <td>{ c.get('criterio') }</td>
                                            <td>{ c.get('calificacion') }</td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                   </table>

                    <table className="table table-condensed table-bordered">
                        <thead>
                            <tr>
                                <th colSpan={2}>Observaciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan={2}>
                                    <div style={{ maxHeight: '80px', overflowX: 'hidden' }}>
                                    { entrega.get('observaciones') || '' }
                                    </div>
                                </td>
                            </tr>
                            {(this.props.documento.get('entregas_parciales') == true) && (
                                <Fragment>
                                    <tr>
                                        <th style={{ width: '60%' }}>Valor a facturar</th>
                                        <td>{ formatcoin((entrega.get('valor_a_facturar') ), divisa.simbolo) }</td>
                                    </tr>
                                </Fragment>
                            )}                            
                        </tbody>
                    </table>

                </div>
            </div>
        )
    }

	render() {

        const { documento, url, type, parametros, divisas } = this.props
        if (!documento) return null

        const moneda = documento.getIn(['cotizacion', 'moneda']);
        const divisa = getDivisa(divisas, moneda)
        const criterios = parametros.get('CRITERIOS_EVALUACION_PROVEEDORES') ? parametros.get('CRITERIOS_EVALUACION_PROVEEDORES') : []

		return (
            <div>

                <BoxSection title={ <span>Promedios</span> }>  

                    <div className="row">
                        <div className="col-md-12">
                            <table className="table table-condensed table-bordered">
                                <thead>
                                    <tr>
                                        <th>Criterio</th>
                                        <th>Calificación</th>
                                    </tr>
                                </thead> 
                                <tbody>
                                    {
                                        criterios.map((a,b) => {
                                            return (
                                                <tr key={`tr9[${b}]`}>
                                                    <td>{a.get('CRITERIO')}</td>
                                                    <td>{ this.promediar(a.get('CRITERIO')) }</td>
                                                </tr>
                                            )
                                        }) 
                                    }  
                                    <tr>
                                        <td>Cumplimiento</td>
                                        <td>{ this.promediar('Cumplimiento') }</td>   
                                    </tr>                                  
                                </tbody>                           
                            </table>                        
                        </div>
                    </div>                
                </BoxSection>

                <div className="separator" />

                {
                    documento.get('entregas').filter(a => a.get('recibido') == false).sort((a,b) => a.get('id') < b.get('id') ? 1 : -1).map((a, b) => {
                        return (
                            <Fragment key={ `fr1[${a.get('id')}]`}>

                                {(b>0) && (<div className="separator" />)}

                                <BoxSection key={ `bs1[${a.get('id')}]` } title={ <span>{ a.get('recibido') ? <FontAwesome name="check" style={{ color: 'green' }} /> : <FontAwesome name="clock-o" /> } Verificación de recibido</span> }>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4>Responsable: { a.getIn(['responsable_recibo', 'fullname']) }</h4>
                                        </div>
                                        <div className="col-md-12">

                                            <b>
                                                Fecha registro: &nbsp; { a.get('recibido') ? <span>{ moment(a.get('updated_at')).format('DD/MM/YYYY hh:mm A') }</span> : 'Sin recibir' }
                                            </b>

                                            <br />

                                            <b>
                                                Fecha recibido: &nbsp; { a.get('recibido') ? <span>{ moment(a.get('fecha')).format('DD/MM/YYYY') }</span> : '' }
                                            </b>

                                            <br />

                                            <b>
                                                Estado: &nbsp; { a.get('recibido') ? <span>Recibido</span> : <span>Sin recibir</span> }
                                            </b>

                                            <br />

                                            <hr />

                                        </div>
                                    </div>
                                    {
                                        this.renderEvaluaciones(a,divisa)
                                    }
                                    {
                                        (!a.get('recibido') &&
                                        isAllowedToViewComponent('responsables_recibo', documento, a.getIn(['responsable_recibo', 'id'])) && 
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div style={{ textAlign: 'right', padding: '10px 0' }}>
                                                        <span>
                                                            <button className="btn btn-primary btn-sm btn-squared" onClick={ e => this.props.showHideModalCreateEntrega(true, a.get('id')) }>Recibir</button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    }
                                </BoxSection>


                            </Fragment>
                        )
                    })
                }

                <div className="separator" />

                {
                    documento.get('verificaciones_sst').map((a, b) => {
                        return (
                            <BoxSection key={ `bs2[${a.get('id')}]` } title={ <span>{ a.get('verificado') ? <FontAwesome name="check" style={{ color: 'green' }} /> : <FontAwesome name="clock-o" /> } Verificación de SOMA</span> }>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h4>Responsable: { a.getIn(['responsable_soma', 'fullname']) }</h4>
                                    </div>
                                    <div className="col-md-12">
                                        <b>
                                            Estado: { a.get('verificado') ? <span>Verificación &bull; { moment(a.get('updated_at')).format('DD/MM/YYYY hh:mm A') }</span> : 'Sin verificar' }
                                        </b>
                                        <hr />
                                    </div>
                                </div>
                                {
                                    (!a.get('verificado') &&
                                    isAllowedToViewComponent('responsable_soma', documento, a.getIn(['responsable_soma', 'id'])) && 
                                        <div className="row">
                                            <div className="col-md-12">
                                                <div style={{ textAlign: 'right', padding: '10px 0' }}>
                                                    <span>
                                                        <button className="btn btn-primary btn-sm btn-squared" onClick={ e => this.props.showHideModalAddVerificacionSOMA(true, a, url, type) }>Verificar</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    (a.get('verificado') &&

                                        <Fragment>

                                            <div className="row" style={{ marginBottom: '5px' }}>
                                                <div className="col-md-12">
                                                    <table className="table table-condensed table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th>Criterio</th>
                                                                <th>Calificación</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>Calificación</td>
                                                                <td>
                                                                    {`${a.get('aceptado') == 1 ? 'Aceptado' : 'No aceptado' }`}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    { a.get('observaciones') && (
                                                        <table className="table table-condensed table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={2}>Observaciones</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td colSpan={2}>
                                                                    <div style={{ maxHeight: '80px', overflowX: 'hidden' }}>
                                                                    { a.get('observaciones') }
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                        </table>
                                                    )} 
                                                </div>                                
                                            </div>

      

                                        </Fragment>

                                    )
                                }
                            </BoxSection>
                        )
                    })
                }

                <div className="separator" />

                {
                    documento.get('entregas').filter(a => a.get('recibido') == true).sort((a,b) => a.get('id') < b.get('id') ? 1 : -1).map((a, b) => {
                        return (
                            <Fragment key={ `fr1[${a.get('id')}]`}>

                                {(b>0) && (<div className="separator" />)}

                                <BoxSection key={ `bs1[${a.get('id')}]` } title={ <span>{ a.get('recibido') ? <FontAwesome name="check" style={{ color: 'green' }} /> : <FontAwesome name="clock-o" /> } Verificación de recibido</span> }>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <h4>Responsable: { a.getIn(['responsable_recibo', 'fullname']) }</h4>
                                        </div>
                                        <div className="col-md-12">

                                            <b>
                                                Fecha registro: &nbsp; { a.get('recibido') ? <span>{ moment(a.get('updated_at')).format('DD/MM/YYYY hh:mm A') }</span> : 'Sin recibir' }
                                            </b>

                                            <br />

                                            <b>
                                                Fecha recibido: &nbsp; { a.get('recibido') ? <span>{ moment(a.get('fecha')).format('DD/MM/YYYY') }</span> : '' }
                                            </b>

                                            <br />

                                            <b>
                                                Estado: &nbsp; { a.get('recibido') ? <span>Recibido</span> : <span>Sin recibir</span> }
                                            </b>

                                            <br />

                                            <hr />

                                        </div>
                                    </div>
                                    
                                    {
                                        this.renderEvaluaciones(a,divisa)
                                    }

                                </BoxSection>


                            </Fragment>
                        )
                    })
                }

                <ModalAddVerificacionSOMA />

            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        url: state.documentos.getIn(['modalSummary', 'url']),
        type: state.documentos.getIn(['modalSummary', 'type']),   
        parametros: state.common.get('parametros'),
        divisas: state.common.getIn(['parametros', 'DIVISAS']) 
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showHideModalCreateEntrega: (show, id) => dispatch(showHideModalCreateEntrega(show, id)),
        showHideModalAddVerificacionSOMA: (show, verificacion, url, type) => dispatch(showHideModalAddVerificacionSOMA(show, verificacion, url, type)),
        getParameterByName: (nombre) => dispatch(getParameterByName(nombre))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Entregas)


// WEBPACK FOOTER //
// ./src/components/Documentos/Entregas.jsx